import React from 'react';
import Box from '@mui/material/Box';
import { Container } from '@mui/material';

import UpdateBankForm from '../Components/UpdateBankForm';

export default function UpdateBankPage() {
  return (
    // component="main"
    <Box  sx={{ flexGrow: 1, p: 3 }}>
      <Container>
        <UpdateBankForm/>
      </Container>
    </Box>
  )
}
